import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import { Edit, Times, IsOpen } from '../../../components/Icon';
import { setVehicleProperty } from '../actions';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import styles from './CardVehicleRemarks.module.css';
import { Textarea } from '../../../components/Textarea';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { Label } from './VehicleCounterLabel';
import { hasPermissions } from '../../../utils/helpers/permissions';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }



  .icon-cross {
    cursor: pointer;
    font-size: 18px;
    width: 20px;
    height: 22px;
  }
  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-edit-square {
    color: #0183D5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
    resize: none;
  }
  textarea {
    height: 200px; !important;
    width: 100%; !important
  }
`;

const STATE = {
  isOpenAddModal: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
  isOpen: true,
};

const ranges = {
  '#00BFAE': [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

/* eslint-disable react/prefer-stateless-function */
class VehicleRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.vehicle?.remarks && this.setState({ remarks: JSON.parse(this.props.vehicle?.remarks) });
    this.props.fetch();
    if (hasPermissions(this.props.permissions, DEP_IT || DEP_COMMERCE)) {
      this.setState({ isOpen: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vehicle?.remarks !== this.props.vehicle?.remarks) {
      const newRemarks = JSON.parse(this.props.vehicle?.remarks || '[]');
      if (JSON.stringify(this.state.remarks) !== JSON.stringify(newRemarks)) {
        this.setState({ remarks: newRemarks });
      }
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.vehicle?.remarks !== this.props.vehicle?.remarks) {
  //     this.setState({ remarks: JSON.parse(this.props.vehicle?.remarks || '[]') });
  //   }
  // }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  handleReset() {
    this.setState({
      isOpenAddModal: false,
      editableRemark: null,
      newRemarkText: '',
    });
  }

  handleModalOpen(remark) {
    this.setState({
      isOpenAddModal: true,
      editableRemark: remark?.id || null,
      newRemarkText: remark?.text || '',
    });
  }

  handleSave() {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, remarks } = this.state;

    const remark = {
      id: Date.now(),
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = [...remarks, remark];
    this.setState({ remarks: updatedRemarks });

    setRemark(JSON.stringify(updatedRemarks), result => {
      if (result) {
        this.handleReset();
      }
    });
  }

  handleEdit(remarkId) {
    const remark = {
      id: remarkId,
      userId: this.props.loggedUser?.id,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const remarks = this.state.remarks?.filter(remark => remark?.id != remarkId);
    const updatedRemarks = [...remarks, remark];

    this.props.setRemark(JSON.stringify(updatedRemarks));
  }

  handleDelete(remarkId) {
    const { setRemark } = this.props;
    const { remarks } = this.state;

    const updatedRemarks = remarks.filter(remark => remark?.id !== remarkId);
    setRemark(JSON.stringify(updatedRemarks));
  }

  renderAddModal() {
    return (
      <ModalComponent
        title={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        onClose={this.handleReset.bind(this)}
      >
        <Textarea
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
          label={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        />

        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={
              this.state.editableRemark ? () => this.handleEdit(this.state.editableRemark) : this.handleSave.bind(this)
            }
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.handleReset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.works) return <LoadingDetailsPageCard />;
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('info.remarks.title')}</h2>
            <Label count="2" ranges={ranges}>
              {' '}
              {this.state.remarks ? this.state.remarks.length : 0}
            </Label>
            <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              <HBox vCenter right style={{ margin: '10px' }}>
                <ButtonComponent
                  style={'ButtonSoftPrimary'}
                  size={'btn-sm'}
                  onClick={() => this.setState({ isOpenAddModal: true })}
                >
                  {this.lbl('info.remarks.add')}
                </ButtonComponent>
              </HBox>

              <List>
                {this.state.remarks
                  ?.sort((a, b) => ((b?.sortingDate ?? b.date) < (a?.sortingDate ?? a.date) ? -1 : 1))
                  ?.map(remark => (
                    <Row key={remark?.id}>
                      <div className={styles.remarkCard}>
                        <HBox className="gap-2" vCenter right>
                          <ButtonComponent
                            style={'ButtonSoftEdit'}
                            disabled={
                              env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id
                            }
                            size={'btn-sm'}
                            onClick={() => {
                              if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                                return;
                              }
                              this.handleModalOpen(remark);
                            }}
                          >
                            <Edit />
                          </ButtonComponent>
                          <ButtonComponent
                            style={'ButtonSoftDelete'}
                            disabled={
                              env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id
                            }
                            size={'btn-sm'}
                            onClick={() => {
                              if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                                return;
                              }
                              this.handleDelete(remark?.id);
                            }}
                          >
                            <Times />
                          </ButtonComponent>
                        </HBox>

                        <VBox className="remark" vCenter>
                          {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                          <div className={styles.remarkText}>
                            <pre>
                              <h6>{remark?.text}</h6>
                            </pre>
                          </div>
                        </VBox>
                        <HBox right>{remark?.date}</HBox>
                      </div>
                    </Row>
                  ))}
              </List>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_USER, `${REQUEST_VEHICLE_PROPERTY_UPDATE}-remarks`, REQUEST_VEHICLE_PROPERTY_UPDATE]),
    loggedUser: selectUser(ownProps?.loggedUserId),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchUser(ownProps?.loggedUserId));
    },
    setRemark(dto, callback) {
      dispatch(setVehicleProperty(ownProps?.vehicle?.id, 'remarks', dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleRemarksCard = compose(withConnect, withRouter)(VehicleRemarksCardComp);
